import {
  ObservationWeightControllerService,
  WeightsInfoResponse
} from "@9amhealth/openapi";
import { Cubit } from "blac-next";
import reportErrorSentry from "src/lib/reportErrorSentry";
import { TranslationKey } from "src/types/translationKey";

type Glp1RefillBlocState = {
  loading: boolean;
  hasWeightReading: boolean;
  weightQualityData: WeightsInfoResponse | null;
  error?: TranslationKey;
};

export default class Glp1RefillBloc extends Cubit<Glp1RefillBlocState> {
  public static WEIGHT_READING_TIME_RANGE_DAYS = 28;

  constructor() {
    super({
      loading: false,
      hasWeightReading: false,
      weightQualityData: null
    });
  }

  checkWeightReading = async () => {
    this.patch({
      loading: true,
      error: undefined
    });

    try {
      const weightQualityData = await this.loadWeightQualityData();
      const hasWeightReading = Boolean(weightQualityData.currentWeight.value);

      this.patch({
        loading: false,
        hasWeightReading,
        weightQualityData
      });
    } catch (e) {
      this.patch({
        loading: false,
        hasWeightReading: false,
        error: "error.fetchingWeightReadings"
      });
      if (e instanceof Error) {
        reportErrorSentry(e);
      }
    }
  };

  loadWeightQualityData = async (): Promise<WeightsInfoResponse> => {
    try {
      const response = await ObservationWeightControllerService.getWeightsInfo(
        Glp1RefillBloc.WEIGHT_READING_TIME_RANGE_DAYS
      );
      return response.data;
    } catch (e) {
      if (e instanceof Error) {
        reportErrorSentry(e);
      }
      throw e;
    }
  };

  reset = () => {
    this.emit({
      loading: false,
      hasWeightReading: false,
      weightQualityData: null
    });
  };
}
